import './styles'

import React, { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import LoadingDisplay from '@nhl/nhl-react-ui/lib/LoadingDisplay';
import ErrorBoundary from '@nhl/nhl-react-ui/lib/ErrorBoundary';

/*
 IMPORTANT:
 All Common reducers need to be defined in the configureStore function in store.js
 */
import PageWrapper from 'media-base-ui/views/layouts/pageWrapper';
import * as commonEnhancers from 'media-base-ui/views/enhancers';

import * as components from '../../components';
import * as enhancers from '../../enhancers';

const AuthenticatedPageWrapper = enhancers.withProfileData(commonEnhancers.withAuthentication(PageWrapper));

const NoMatch = lazy(() => import('media-base-ui/views/pages/noMatch'));

const Profile = lazy(() => import('../../pages/profile'));
const EmailSubscriptions = lazy(() => import('../../pages/emailSubscriptions'));
const Password = lazy(() => import('../../pages/password'));

const App = () => {
    return (
        <AuthenticatedPageWrapper
            authenticated={true}
            isAccountApp={true}>
                <div className="authenticated-container">
                    <ErrorBoundary>
                        <components.SidebarMenu />
                        <Suspense fallback={<LoadingDisplay isLoading={true}/>}>
                            <Routes>
                                <Route
                                    path="profile"
                                    element={<Profile createMode={false} />}
                                />
                                <Route
                                    path="subscriptions"
                                    element={<EmailSubscriptions createMode={false} />}
                                />
                                <Route path="password" element={<Password />}/>
                                <Route element={<NoMatch />} />
                            </Routes>
                        </Suspense>
                    </ErrorBoundary>
                </div>
        </AuthenticatedPageWrapper>
    );
};

export default App;
